/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { profileReportAveragesData } from '../fn/profile-report/profile-report-averages-data';
import { ProfileReportAveragesData$Params } from '../fn/profile-report/profile-report-averages-data';
import { ProfileReportData } from '../models/profile-report-data';
import { profileReportMarketDownload } from '../fn/profile-report/profile-report-market-download';
import { ProfileReportMarketDownload$Params } from '../fn/profile-report/profile-report-market-download';
import { ProfileReportResponse } from '../models/profile-report-response';
import { profileReportSummaryData } from '../fn/profile-report/profile-report-summary-data';
import { ProfileReportSummaryData$Params } from '../fn/profile-report/profile-report-summary-data';
import { profileReportSummaryDownload } from '../fn/profile-report/profile-report-summary-download';
import { ProfileReportSummaryDownload$Params } from '../fn/profile-report/profile-report-summary-download';
import { profileReportTimeCompareDownload } from '../fn/profile-report/profile-report-time-compare-download';
import { ProfileReportTimeCompareDownload$Params } from '../fn/profile-report/profile-report-time-compare-download';

@Injectable({ providedIn: 'root' })
export class ProfileReportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `profileReportSummaryData()` */
  static readonly ProfileReportSummaryDataPath = '/rest/profile/{id}/report/summary/{from}/{to}';

  /**
   * Generate summary report data for profile. Returned data are computed for range of time defines as parameters - FROM to TO. If from FROM parameter is set to 1 than used is full history. TO cannot be before FROM.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileReportSummaryData()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileReportSummaryData$Response(params: ProfileReportSummaryData$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileReportData>> {
    return profileReportSummaryData(this.http, this.rootUrl, params, context);
  }

  /**
   * Generate summary report data for profile. Returned data are computed for range of time defines as parameters - FROM to TO. If from FROM parameter is set to 1 than used is full history. TO cannot be before FROM.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileReportSummaryData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileReportSummaryData(params: ProfileReportSummaryData$Params, context?: HttpContext): Observable<ProfileReportData> {
    return this.profileReportSummaryData$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileReportData>): ProfileReportData => r.body)
    );
  }

  /** Path part for operation `profileReportSummaryDownload()` */
  static readonly ProfileReportSummaryDownloadPath = '/rest/profile/{id}/report/summary/{from}/{to}';

  /**
   * Download summary report (PDF) for profile. Returned data are computed for range of time defines as parameters - FROM to TO.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileReportSummaryDownload()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileReportSummaryDownload$Response(params: ProfileReportSummaryDownload$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileReportResponse>> {
    return profileReportSummaryDownload(this.http, this.rootUrl, params, context);
  }

  /**
   * Download summary report (PDF) for profile. Returned data are computed for range of time defines as parameters - FROM to TO.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileReportSummaryDownload$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileReportSummaryDownload(params: ProfileReportSummaryDownload$Params, context?: HttpContext): Observable<ProfileReportResponse> {
    return this.profileReportSummaryDownload$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileReportResponse>): ProfileReportResponse => r.body)
    );
  }

  /** Path part for operation `profileReportTimeCompareDownload()` */
  static readonly ProfileReportTimeCompareDownloadPath = '/rest/profile/{id}/report/time-compare/{firstRangeFrom}/{firstRangeTo}/{secondRangeFrom}/{secondRangeTo}';

  /**
   * Download time compare report (PDF) for profile. Returned data are computed for two range of times defined as with parameters - FROM to TO.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileReportTimeCompareDownload()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileReportTimeCompareDownload$Response(params: ProfileReportTimeCompareDownload$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileReportResponse>> {
    return profileReportTimeCompareDownload(this.http, this.rootUrl, params, context);
  }

  /**
   * Download time compare report (PDF) for profile. Returned data are computed for two range of times defined as with parameters - FROM to TO.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileReportTimeCompareDownload$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileReportTimeCompareDownload(params: ProfileReportTimeCompareDownload$Params, context?: HttpContext): Observable<ProfileReportResponse> {
    return this.profileReportTimeCompareDownload$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileReportResponse>): ProfileReportResponse => r.body)
    );
  }

  /** Path part for operation `profileReportAveragesData()` */
  static readonly ProfileReportAveragesDataPath = '/rest/profile/{id}/report/market/{type}/{from}/{to}';

  /**
   * Generate average report data for by type. Profile defined in path is always excluded from statistics. Type can be Smarthead (all SmartHead profile) or all profiles with same Industry/CoMpanySize/Industry and CompanySize as profile defined in path.Returned data are computed for range of time defines as parameters - FROM to TO. If from FROM parameter is set to 1 than used is full history. TO cannot be before FROM.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileReportAveragesData()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileReportAveragesData$Response(params: ProfileReportAveragesData$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileReportData>> {
    return profileReportAveragesData(this.http, this.rootUrl, params, context);
  }

  /**
   * Generate average report data for by type. Profile defined in path is always excluded from statistics. Type can be Smarthead (all SmartHead profile) or all profiles with same Industry/CoMpanySize/Industry and CompanySize as profile defined in path.Returned data are computed for range of time defines as parameters - FROM to TO. If from FROM parameter is set to 1 than used is full history. TO cannot be before FROM.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileReportAveragesData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  profileReportAveragesData(params: ProfileReportAveragesData$Params, context?: HttpContext): Observable<ProfileReportData> {
    return this.profileReportAveragesData$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileReportData>): ProfileReportData => r.body)
    );
  }

  /** Path part for operation `profileReportMarketDownload()` */
  static readonly ProfileReportMarketDownloadPath = '/rest/profile/{id}/report/market/{type}/{from}/{to}';

  /**
   * Download martket report (PDF) for profile. Returned data are computed for range of time defines as parameters - FROM to TO and for TYPE (which data to compare with).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `profileReportMarketDownload()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileReportMarketDownload$Response(params: ProfileReportMarketDownload$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileReportResponse>> {
    return profileReportMarketDownload(this.http, this.rootUrl, params, context);
  }

  /**
   * Download martket report (PDF) for profile. Returned data are computed for range of time defines as parameters - FROM to TO and for TYPE (which data to compare with).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `profileReportMarketDownload$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  profileReportMarketDownload(params: ProfileReportMarketDownload$Params, context?: HttpContext): Observable<ProfileReportResponse> {
    return this.profileReportMarketDownload$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileReportResponse>): ProfileReportResponse => r.body)
    );
  }

}
